import { formatDraftTime } from '../hooks/useCampaignDraft';

interface RestoreDraftBannerProps {
  savedAt: string;
  step: number;
  onRestore: () => void;
  onDiscard: () => void;
}

const STEP_LABELS: Record<number, string> = {
  1: 'الأساسيات',
  2: 'التفاصيل',
  3: 'الهدف المالي',
  4: 'المراجعة',
};

const RestoreDraftBanner = ({ savedAt, step, onRestore, onDiscard }: RestoreDraftBannerProps) => (
  <div
    className="bg-amber-50 border border-amber-200 rounded-2xl p-4 mb-6 flex flex-col sm:flex-row sm:items-center gap-3"
    dir="rtl"
  >
    <div className="flex items-start gap-3 flex-1">
      <div className="w-9 h-9 flex items-center justify-center bg-amber-100 rounded-full shrink-0 mt-0.5">
        <i className="ri-draft-line text-amber-600 text-base"></i>
      </div>
      <div>
        <p className="text-sm font-bold text-amber-800">لديك مسودة محفوظة</p>
        <p className="text-xs text-amber-600 mt-0.5">
          توقفت عند خطوة <strong>{STEP_LABELS[step] ?? step}</strong> · حُفظت {formatDraftTime(savedAt)}
        </p>
      </div>
    </div>

    <div className="flex items-center gap-2 shrink-0 mr-auto">
      <button
        onClick={onDiscard}
        className="px-3 py-1.5 rounded-lg text-xs font-semibold text-amber-700 hover:bg-amber-100 transition-colors cursor-pointer whitespace-nowrap"
      >
        تجاهل
      </button>
      <button
        onClick={onRestore}
        className="px-4 py-1.5 rounded-lg text-xs font-bold bg-amber-500 text-white hover:bg-amber-600 transition-colors cursor-pointer whitespace-nowrap"
      >
        <i className="ri-arrow-go-back-line ml-1"></i>
        استكمال المسودة
      </button>
    </div>
  </div>
);

export default RestoreDraftBanner;
